// src/components/admin/AdminLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";

const AdminLayout: React.FC = () => (
  <div style={{ display: "flex", minHeight: "100vh" }}>
    <AdminSidebar />
    <main style={{ flex: 1, padding: "32px", background: "#f7fafd" }}>
      <Outlet />
    </main>
  </div>
);

export default AdminLayout;
